<footer>

    <div class="footer-bg ">
        <div class="container-fluid">
            <div class="row  align-items-center">
                <div class="col-md-4">
                    <div class="footer-widget__text ">
                        <p>For support or feature request please contact 
                           <b> <a class="email-link" href="mailto:support&#64;coincuriosity.us">support&#64;coincuriosity.us</a>
                           </b>
                        </p>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="footer-logo">
                        <img src="assets/images/footer/footer-logo.png" class="img-fluid" alt="footer logo">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="footer-widget__social">
                        <a href="https://www.instagram.com/coincuriosity/" target="_blank" class="margin-r-20"><i class="fab fa-instagram"></i></a>
                        <a href="https://www.youtube.com/channel/UCD1BCINrKWVWfJoF-CHMgpA" target="_blank"><i class="bi bi-youtube"></i></a>
                    </div>
                    
                </div>
            </div>

            <div class="footer-copyright">
                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-12">
                            <div class="f-copyright__dom"><span>Copyright {{currentYear}}, All rights reserved.</span></div>
                        </div>
                        <div class="col-lg-8 col-md-8 col-12">
                            <div class="f-copyright__list ">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0)" routerLink="/privacy-policy">Privacy Policy </a>
                                    </li>
                                    <div class="h-line"></div>
                                    <li>
                                        <a href="javascript:void(0)" routerLink="/terms-and-conditions"> Terms & Conditions</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    </div>

    <button (click)="scrollToTop()"  class="scrollto__topbtn " *ngIf="showButton"><i class="bi bi-arrow-up-short"></i></button>

    

</footer>
